module.exports = __webpack_public_path__ + "static/media/FlyOut_Triangle@3x.878de293.png";